import { ThemeColors } from '@/theme/types'

export const conexa: ThemeColors = {
  primary: {
    100: '#E6EAF7',
    200: '#BFCBEC',
    300: '#8098D8',
    400: '#4064C5',
    500: '#0031B2',
    600: '#002A97',
    700: '#00227D',
    800: '#001B62',
    900: '#001447',
  },
  secondary: {
    100: '#FCE6E6',
    200: '#FACCCC',
    300: '#F7B3B3',
    400: '#F59999',
    500: '#F28080',
    600: '#CE6D6D',
    700: '#A95A5A',
    800: '#854646',
    900: '#613333',
  },
}
